export default "__VITE_ASSET__9xJQKHCZ__"